import axios from "@lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export interface Inputs {
  name: string;
  active?: boolean;
}

interface UseSavePersonProps {
  personId?: string;
  onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSavePerson = ({
  personId,
  onSuccess,
  onError,
}: UseSavePersonProps) => {
  const queryClient = useQueryClient();
  const {
    isPending,
    isError,
    error,
    mutate: onSavePerson,
  } = useMutation({
    mutationFn: async (data: Inputs) => {
      if (personId) return axios.patch(`/people/${personId}`, data);
      return axios.post("/people", data);
    },
    onSuccess: (data) => {
      if (personId)
        queryClient.invalidateQueries({
          queryKey: ["people", personId],
        });
      if (onSuccess) onSuccess(data);
    },
    onError,
  });

  return { onSavePerson, isPending, isError, error };
};
